import { render, staticRenderFns } from "./scroll_list_m.vue?vue&type=template&id=39d574b4&scoped=true&"
import script from "./scroll_list_m.vue?vue&type=script&lang=js&"
export * from "./scroll_list_m.vue?vue&type=script&lang=js&"
import style0 from "./scroll_list_m.vue?vue&type=style&index=0&id=39d574b4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d574b4",
  null
  
)

export default component.exports